var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "wizard" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "wizard__body" }, [
      _c("div", { staticClass: "body__content" }, [
        _c(
          "div",
          { staticClass: "wizard__content", attrs: { id: "wizard__content" } },
          [
            _c(
              "form-wizard",
              {
                attrs: {
                  shape: "circle",
                  color: "#19557f",
                  title: "Platform Wizard",
                  subtitle: "",
                  stepSize: "xs",
                  finishButtonText: "Next",
                  validateOnBack: false
                },
                on: {
                  "on-change": _vm.slideChange,
                  "on-complete": _vm.wizardComplete
                },
                scopedSlots: _vm._u([
                  {
                    key: "footer",
                    fn: function(props) {
                      return [
                        _c("div", { staticClass: "wizard-footer-left" }, [
                          props.activeTabIndex > 0
                            ? _c(
                                "button",
                                {
                                  staticClass: "wizard-btn",
                                  style: props.fillButtonStyle,
                                  attrs: { id: "wizard-previous-button" },
                                  on: {
                                    click: function($event) {
                                      return props.prevTab()
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                Previous\n              "
                                  )
                                ]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "wizard-footer-right" }, [
                          _c(
                            "button",
                            {
                              staticClass: "wizard-btn",
                              style: props.fillButtonStyle,
                              attrs: { id: "wizard-next-button" },
                              on: {
                                click: function($event) {
                                  return props.nextTab()
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(props.isLastStep ? "Done" : "Next") +
                                  "\n              "
                              )
                            ]
                          )
                        ])
                      ]
                    }
                  }
                ])
              },
              [
                _c("tab-content", { attrs: { beforeChange: _vm.checkSlide } }, [
                  _c(
                    "div",
                    {
                      class: [
                        "wizard-field",
                        "wizard-field--stacked",
                        {
                          "has-error": _vm.errors
                            ? _vm.errors.has("core_benefits")
                            : false
                        }
                      ]
                    },
                    [
                      _c("h3", { staticClass: "wizard-question" }, [
                        _vm._v("Do you need support for core benefits?")
                      ]),
                      _vm._v(" "),
                      _c(
                        "radio",
                        {
                          attrs: { name: "core_benefits", value: true },
                          model: {
                            value: _vm.wizardAnswers.core_benefits,
                            callback: function($$v) {
                              _vm.$set(_vm.wizardAnswers, "core_benefits", $$v)
                            },
                            expression: "wizardAnswers.core_benefits"
                          }
                        },
                        [_vm._v("\n                Yes\n              ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "radio",
                        {
                          attrs: { name: "core_benefits", value: false },
                          nativeOn: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.shortCircuitToHarmony($event)
                            }
                          },
                          model: {
                            value: _vm.wizardAnswers.core_benefits,
                            callback: function($$v) {
                              _vm.$set(_vm.wizardAnswers, "core_benefits", $$v)
                            },
                            expression: "wizardAnswers.core_benefits"
                          }
                        },
                        [_vm._v("\n                No\n              ")]
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("tab-content", { attrs: { beforeChange: _vm.checkSlide } }, [
                  _c("h3", { staticClass: "wizard-question" }, [
                    _vm._v("Which products will you be offering?")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      class: [
                        "wizard-field wizard-field--checkbox",
                        {
                          "has-error": _vm.errors
                            ? _vm.errors.has("accident_stand_alone")
                            : false
                        }
                      ]
                    },
                    [
                      _c(
                        "checkbox",
                        {
                          attrs: { name: "accident" },
                          model: {
                            value:
                              _vm.wizardAnswers.products.accident.supported,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.wizardAnswers.products.accident,
                                "supported",
                                $$v
                              )
                            },
                            expression:
                              "wizardAnswers.products.accident.supported"
                          }
                        },
                        [
                          _vm._v(
                            "\n                Accident Insurance\n              "
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      class: {
                        "wizard-field wizard-field--conditional": true,
                        "wizard-field--disabled": !_vm.wizardAnswers.products
                          .accident.supported,
                        "has-error":
                          !_vm.slideChangeSuccess &&
                          _vm.wizardAnswers.products.accident.supported &&
                          _vm.wizardAnswers.products.accident
                            .standAlonePoliciesSupported === null
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "wizard-field--conditional__question" },
                        [
                          _vm._v(
                            "\n                Will spouse/child standalone policies be needed?\n              "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "wizard-field--radio" },
                        [
                          _c(
                            "radio",
                            {
                              attrs: {
                                name: "accident_stand_alone",
                                value: _vm.wizardAnswers.products.accident
                                  .supported
                                  ? true
                                  : null,
                                disabled: !_vm.wizardAnswers.products.accident
                                  .supported
                              },
                              model: {
                                value:
                                  _vm.wizardAnswers.products.accident
                                    .standAlonePoliciesSupported,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.wizardAnswers.products.accident,
                                    "standAlonePoliciesSupported",
                                    $$v
                                  )
                                },
                                expression:
                                  "wizardAnswers.products.accident.standAlonePoliciesSupported"
                              }
                            },
                            [
                              _vm._v(
                                "\n                  Yes\n                "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "radio",
                            {
                              attrs: {
                                name: "accident_stand_alone",
                                value: _vm.wizardAnswers.products.accident
                                  .supported
                                  ? false
                                  : null,
                                disabled: !_vm.wizardAnswers.products.accident
                                  .supported
                              },
                              model: {
                                value:
                                  _vm.wizardAnswers.products.accident
                                    .standAlonePoliciesSupported,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.wizardAnswers.products.accident,
                                    "standAlonePoliciesSupported",
                                    $$v
                                  )
                                },
                                expression:
                                  "wizardAnswers.products.accident.standAlonePoliciesSupported"
                              }
                            },
                            [_vm._v("\n                  No\n                ")]
                          )
                        ],
                        1
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "wizard-field wizard-field--checkbox" },
                    [
                      _c(
                        "checkbox",
                        {
                          attrs: { name: "group_accident" },
                          model: {
                            value:
                              _vm.wizardAnswers.products.group_accident
                                .supported,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.wizardAnswers.products.group_accident,
                                "supported",
                                $$v
                              )
                            },
                            expression:
                              "wizardAnswers.products.group_accident.supported"
                          }
                        },
                        [
                          _vm._v(
                            "\n                Group Accident\n              "
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      class: [
                        "wizard-field wizard-field--checkbox",
                        {
                          "has-error": _vm.errors
                            ? _vm.errors.has("cancer_stand_alone")
                            : false
                        }
                      ]
                    },
                    [
                      _c(
                        "checkbox",
                        {
                          attrs: { name: "cancer" },
                          model: {
                            value: _vm.wizardAnswers.products.cancer.supported,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.wizardAnswers.products.cancer,
                                "supported",
                                $$v
                              )
                            },
                            expression:
                              "wizardAnswers.products.cancer.supported"
                          }
                        },
                        [
                          _vm._v(
                            "\n                Cancer Insurance\n              "
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      class: {
                        "wizard-field wizard-field--conditional": true,
                        "wizard-field--disabled": !_vm.wizardAnswers.products
                          .cancer.supported,
                        "has-error":
                          !_vm.slideChangeSuccess &&
                          _vm.wizardAnswers.products.cancer.supported &&
                          _vm.wizardAnswers.products.cancer
                            .standAlonePoliciesSupported === null
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "wizard-field--conditional__question" },
                        [
                          _vm._v(
                            "\n                Will spouse/child standalone policies be needed?\n              "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "wizard-field--radio" },
                        [
                          _c(
                            "radio",
                            {
                              attrs: {
                                name: "cancer_stand_alone",
                                value: _vm.wizardAnswers.products.cancer
                                  .supported
                                  ? true
                                  : null,
                                disabled: !_vm.wizardAnswers.products.cancer
                                  .supported
                              },
                              model: {
                                value:
                                  _vm.wizardAnswers.products.cancer
                                    .standAlonePoliciesSupported,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.wizardAnswers.products.cancer,
                                    "standAlonePoliciesSupported",
                                    $$v
                                  )
                                },
                                expression:
                                  "wizardAnswers.products.cancer.standAlonePoliciesSupported"
                              }
                            },
                            [
                              _vm._v(
                                "\n                  Yes\n                "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "radio",
                            {
                              attrs: {
                                name: "cancer_stand_alone",
                                value: _vm.wizardAnswers.products.cancer
                                  .supported
                                  ? false
                                  : null,
                                disabled: !_vm.wizardAnswers.products.cancer
                                  .supported
                              },
                              model: {
                                value:
                                  _vm.wizardAnswers.products.cancer
                                    .standAlonePoliciesSupported,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.wizardAnswers.products.cancer,
                                    "standAlonePoliciesSupported",
                                    $$v
                                  )
                                },
                                expression:
                                  "wizardAnswers.products.cancer.standAlonePoliciesSupported"
                              }
                            },
                            [_vm._v("\n                  No\n                ")]
                          )
                        ],
                        1
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "wizard-field wizard-field--checkbox" },
                    [
                      _c(
                        "checkbox",
                        {
                          attrs: { name: "critical_illness" },
                          model: {
                            value:
                              _vm.wizardAnswers.products.critical_illness
                                .supported,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.wizardAnswers.products.critical_illness,
                                "supported",
                                $$v
                              )
                            },
                            expression:
                              "wizardAnswers.products.critical_illness.supported"
                          }
                        },
                        [
                          _vm._v(
                            "\n                Critical Illness Insurance\n              "
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "wizard-field wizard-field--checkbox" },
                    [
                      _c(
                        "checkbox",
                        {
                          attrs: { name: "group_specified_disease" },
                          model: {
                            value:
                              _vm.wizardAnswers.products.group_specified_disease
                                .supported,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.wizardAnswers.products
                                  .group_specified_disease,
                                "supported",
                                $$v
                              )
                            },
                            expression:
                              "wizardAnswers.products.group_specified_disease.supported"
                          }
                        },
                        [
                          _vm._v(
                            "\n                Group Specified Disease Insurance\n              "
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "wizard-field wizard-field--checkbox" },
                    [
                      _c(
                        "checkbox",
                        {
                          attrs: { name: "dental" },
                          model: {
                            value: _vm.wizardAnswers.products.dental.supported,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.wizardAnswers.products.dental,
                                "supported",
                                $$v
                              )
                            },
                            expression:
                              "wizardAnswers.products.dental.supported"
                          }
                        },
                        [
                          _vm._v(
                            "\n                Dental Insurance\n              "
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "wizard-field wizard-field--checkbox" },
                    [
                      _c(
                        "checkbox",
                        {
                          attrs: { name: "disability" },
                          model: {
                            value:
                              _vm.wizardAnswers.products.disability.supported,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.wizardAnswers.products.disability,
                                "supported",
                                $$v
                              )
                            },
                            expression:
                              "wizardAnswers.products.disability.supported"
                          }
                        },
                        [
                          _vm._v(
                            "\n                Disability Insurance\n              "
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "wizard-field wizard-field--checkbox" },
                    [
                      _c(
                        "checkbox",
                        {
                          attrs: { name: "group_disability" },
                          model: {
                            value:
                              _vm.wizardAnswers.products.group_disability
                                .supported,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.wizardAnswers.products.group_disability,
                                "supported",
                                $$v
                              )
                            },
                            expression:
                              "wizardAnswers.products.group_disability.supported"
                          }
                        },
                        [
                          _vm._v(
                            "\n                Group Disability Insurance\n              "
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "wizard-field wizard-field--checkbox" },
                    [
                      _c(
                        "checkbox",
                        {
                          attrs: { name: "hospital_confinement" },
                          model: {
                            value:
                              _vm.wizardAnswers.products.hospital_confinement
                                .supported,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.wizardAnswers.products.hospital_confinement,
                                "supported",
                                $$v
                              )
                            },
                            expression:
                              "wizardAnswers.products.hospital_confinement.supported"
                          }
                        },
                        [
                          _vm._v(
                            "\n                Hospital Confinement Insurance\n              "
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "wizard-field wizard-field--checkbox" },
                    [
                      _c(
                        "checkbox",
                        {
                          attrs: { name: "group_hospital_indemnity" },
                          model: {
                            value:
                              _vm.wizardAnswers.products
                                .group_hospital_indemnity.supported,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.wizardAnswers.products
                                  .group_hospital_indemnity,
                                "supported",
                                $$v
                              )
                            },
                            expression:
                              "wizardAnswers.products.group_hospital_indemnity.supported"
                          }
                        },
                        [
                          _vm._v(
                            "\n                Group Hospital Indemnity Insurance\n              "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("tab-content", { attrs: { beforeChange: _vm.checkSlide } }, [
                  _c("h3", { staticClass: "wizard-question" }, [
                    _vm._v("Which products will you be offering? (continued)")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      class: [
                        "wizard-field wizard-field--checkbox",
                        {
                          "has-error": _vm.errors
                            ? _vm.errors.has("term_life_stand_alone") ||
                              _vm.errors.has("term_life_stacked")
                            : false
                        }
                      ]
                    },
                    [
                      _c(
                        "checkbox",
                        {
                          attrs: { name: "term_life" },
                          model: {
                            value:
                              _vm.wizardAnswers.products.term_life.supported,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.wizardAnswers.products.term_life,
                                "supported",
                                $$v
                              )
                            },
                            expression:
                              "wizardAnswers.products.term_life.supported"
                          }
                        },
                        [
                          _vm._v(
                            "\n                Term Life Insurance\n              "
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      class: {
                        "wizard-field wizard-field--conditional": true,
                        "wizard-field--disabled": !_vm.wizardAnswers.products
                          .term_life.supported,
                        "has-error":
                          !_vm.slideChangeSuccess &&
                          _vm.wizardAnswers.products.term_life.supported &&
                          _vm.wizardAnswers.products.term_life
                            .standAlonePoliciesSupported === null
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "wizard-field--conditional__question" },
                        [
                          _vm._v(
                            "\n                Will spouse/child standalone policies be needed?\n              "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "wizard-field--radio" },
                        [
                          _c(
                            "radio",
                            {
                              attrs: {
                                name: "term_life_stand_alone",
                                value: _vm.wizardAnswers.products.term_life
                                  .supported
                                  ? true
                                  : null,
                                disabled: !_vm.wizardAnswers.products.term_life
                                  .supported
                              },
                              model: {
                                value:
                                  _vm.wizardAnswers.products.term_life
                                    .standAlonePoliciesSupported,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.wizardAnswers.products.term_life,
                                    "standAlonePoliciesSupported",
                                    $$v
                                  )
                                },
                                expression:
                                  "wizardAnswers.products.term_life.standAlonePoliciesSupported"
                              }
                            },
                            [
                              _vm._v(
                                "\n                  Yes\n                "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "radio",
                            {
                              attrs: {
                                name: "term_life_stand_alone",
                                value: _vm.wizardAnswers.products.term_life
                                  .supported
                                  ? false
                                  : null,
                                disabled: !_vm.wizardAnswers.products.term_life
                                  .supported
                              },
                              model: {
                                value:
                                  _vm.wizardAnswers.products.term_life
                                    .standAlonePoliciesSupported,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.wizardAnswers.products.term_life,
                                    "standAlonePoliciesSupported",
                                    $$v
                                  )
                                },
                                expression:
                                  "wizardAnswers.products.term_life.standAlonePoliciesSupported"
                              }
                            },
                            [_vm._v("\n                  No\n                ")]
                          )
                        ],
                        1
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      class: {
                        "wizard-field wizard-field--conditional": true,
                        "wizard-field--disabled": !_vm.wizardAnswers.products
                          .term_life.supported,
                        "has-error":
                          !_vm.slideChangeSuccess &&
                          _vm.wizardAnswers.products.term_life.supported &&
                          _vm.wizardAnswers.products.term_life
                            .stackedCoverageSupported === null
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "wizard-field--conditional__question" },
                        [
                          _vm._v(
                            "\n                Will stacked coverage be needed?\n              "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "wizard-field--radio" },
                        [
                          _c(
                            "radio",
                            {
                              attrs: {
                                name: "term_life_stacked",
                                value: _vm.wizardAnswers.products.term_life
                                  .supported
                                  ? true
                                  : null,
                                disabled: !_vm.wizardAnswers.products.term_life
                                  .supported
                              },
                              model: {
                                value:
                                  _vm.wizardAnswers.products.term_life
                                    .stackedCoverageSupported,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.wizardAnswers.products.term_life,
                                    "stackedCoverageSupported",
                                    $$v
                                  )
                                },
                                expression:
                                  "wizardAnswers.products.term_life.stackedCoverageSupported"
                              }
                            },
                            [
                              _vm._v(
                                "\n                  Yes\n                "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "radio",
                            {
                              attrs: {
                                name: "term_life_stacked",
                                value: _vm.wizardAnswers.products.term_life
                                  .supported
                                  ? false
                                  : null,
                                disabled: !_vm.wizardAnswers.products.term_life
                                  .supported
                              },
                              model: {
                                value:
                                  _vm.wizardAnswers.products.term_life
                                    .stackedCoverageSupported,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.wizardAnswers.products.term_life,
                                    "stackedCoverageSupported",
                                    $$v
                                  )
                                },
                                expression:
                                  "wizardAnswers.products.term_life.stackedCoverageSupported"
                              }
                            },
                            [_vm._v("\n                  No\n                ")]
                          )
                        ],
                        1
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "wizard-field wizard-field--checkbox" },
                    [
                      _c(
                        "checkbox",
                        {
                          attrs: {
                            name: "group_term_life",
                            id: "group-term-life-checkbox"
                          },
                          model: {
                            value:
                              _vm.wizardAnswers.products.group_term_life
                                .supported,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.wizardAnswers.products.group_term_life,
                                "supported",
                                $$v
                              )
                            },
                            expression:
                              "wizardAnswers.products.group_term_life.supported"
                          }
                        },
                        [
                          _vm._v(
                            "\n                Group Term Life\n              "
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      class: [
                        "wizard-field wizard-field--checkbox",
                        {
                          "has-error": _vm.errors
                            ? _vm.errors.has("universal_life_stand_alone") ||
                              _vm.errors.has("universal_life_stacked")
                            : false
                        }
                      ]
                    },
                    [
                      _c(
                        "checkbox",
                        {
                          attrs: { name: "universal_life" },
                          model: {
                            value:
                              _vm.wizardAnswers.products.universal_life
                                .supported,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.wizardAnswers.products.universal_life,
                                "supported",
                                $$v
                              )
                            },
                            expression:
                              "wizardAnswers.products.universal_life.supported"
                          }
                        },
                        [
                          _vm._v(
                            "\n                Universal Life Insurance\n              "
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      class: {
                        "wizard-field wizard-field--conditional": true,
                        "wizard-field--disabled": !_vm.wizardAnswers.products
                          .universal_life.supported,
                        "has-error":
                          !_vm.slideChangeSuccess &&
                          _vm.wizardAnswers.products.universal_life.supported &&
                          _vm.wizardAnswers.products.universal_life
                            .standAlonePoliciesSupported === null
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "wizard-field--conditional__question" },
                        [
                          _vm._v(
                            "\n                Will spouse/child standalone policies be needed?\n              "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "wizard-field--radio" },
                        [
                          _c(
                            "radio",
                            {
                              attrs: {
                                name: "universal_life_stand_alone",
                                value: _vm.wizardAnswers.products.universal_life
                                  .supported
                                  ? true
                                  : null,
                                disabled: !_vm.wizardAnswers.products
                                  .universal_life.supported
                              },
                              model: {
                                value:
                                  _vm.wizardAnswers.products.universal_life
                                    .standAlonePoliciesSupported,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.wizardAnswers.products.universal_life,
                                    "standAlonePoliciesSupported",
                                    $$v
                                  )
                                },
                                expression:
                                  "wizardAnswers.products.universal_life.standAlonePoliciesSupported"
                              }
                            },
                            [
                              _vm._v(
                                "\n                  Yes\n                "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "radio",
                            {
                              attrs: {
                                name: "universal_life_stand_alone",
                                value: _vm.wizardAnswers.products.universal_life
                                  .supported
                                  ? false
                                  : null,
                                disabled: !_vm.wizardAnswers.products
                                  .universal_life.supported
                              },
                              model: {
                                value:
                                  _vm.wizardAnswers.products.universal_life
                                    .standAlonePoliciesSupported,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.wizardAnswers.products.universal_life,
                                    "standAlonePoliciesSupported",
                                    $$v
                                  )
                                },
                                expression:
                                  "wizardAnswers.products.universal_life.standAlonePoliciesSupported"
                              }
                            },
                            [_vm._v("\n                  No\n                ")]
                          )
                        ],
                        1
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      class: {
                        "wizard-field wizard-field--conditional": true,
                        "wizard-field--disabled": !_vm.wizardAnswers.products
                          .universal_life.supported,
                        "has-error":
                          !_vm.slideChangeSuccess &&
                          _vm.wizardAnswers.products.universal_life.supported &&
                          _vm.wizardAnswers.products.universal_life
                            .stackedCoverageSupported === null
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "wizard-field--conditional__question" },
                        [
                          _vm._v(
                            "\n                Will stacked coverage be needed?\n              "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "wizard-field--radio" },
                        [
                          _c(
                            "radio",
                            {
                              attrs: {
                                name: "universal_life_stacked",
                                value: _vm.wizardAnswers.products.universal_life
                                  .supported
                                  ? true
                                  : null,
                                disabled: !_vm.wizardAnswers.products
                                  .universal_life.supported
                              },
                              model: {
                                value:
                                  _vm.wizardAnswers.products.universal_life
                                    .stackedCoverageSupported,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.wizardAnswers.products.universal_life,
                                    "stackedCoverageSupported",
                                    $$v
                                  )
                                },
                                expression:
                                  "wizardAnswers.products.universal_life.stackedCoverageSupported"
                              }
                            },
                            [
                              _vm._v(
                                "\n                  Yes\n                "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "radio",
                            {
                              attrs: {
                                name: "universal_life_stacked",
                                value: _vm.wizardAnswers.products.universal_life
                                  .supported
                                  ? false
                                  : null,
                                disabled: !_vm.wizardAnswers.products
                                  .universal_life.supported
                              },
                              model: {
                                value:
                                  _vm.wizardAnswers.products.universal_life
                                    .stackedCoverageSupported,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.wizardAnswers.products.universal_life,
                                    "stackedCoverageSupported",
                                    $$v
                                  )
                                },
                                expression:
                                  "wizardAnswers.products.universal_life.stackedCoverageSupported"
                              }
                            },
                            [_vm._v("\n                  No\n                ")]
                          )
                        ],
                        1
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      class: [
                        "wizard-field wizard-field--checkbox",
                        {
                          "has-error": _vm.errors
                            ? _vm.errors.has("whole_life_stand_alone") ||
                              _vm.errors.has("whole_life_stacked")
                            : false
                        }
                      ]
                    },
                    [
                      _c(
                        "checkbox",
                        {
                          attrs: { name: "whole_life" },
                          model: {
                            value:
                              _vm.wizardAnswers.products.whole_life.supported,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.wizardAnswers.products.whole_life,
                                "supported",
                                $$v
                              )
                            },
                            expression:
                              "wizardAnswers.products.whole_life.supported"
                          }
                        },
                        [
                          _vm._v(
                            "\n                Whole Life Insurance\n              "
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      class: {
                        "wizard-field wizard-field--conditional": true,
                        "wizard-field--disabled": !_vm.wizardAnswers.products
                          .whole_life.supported,
                        "has-error":
                          !_vm.slideChangeSuccess &&
                          _vm.wizardAnswers.products.whole_life.supported &&
                          _vm.wizardAnswers.products.whole_life
                            .standAlonePoliciesSupported === null
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "wizard-field--conditional__question" },
                        [
                          _vm._v(
                            "\n                Will spouse/child standalone policies be needed?\n              "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "wizard-field--radio" },
                        [
                          _c(
                            "radio",
                            {
                              attrs: {
                                name: "whole_life_stand_alone",
                                value: _vm.wizardAnswers.products.whole_life
                                  .supported
                                  ? true
                                  : null,
                                disabled: !_vm.wizardAnswers.products.whole_life
                                  .supported
                              },
                              model: {
                                value:
                                  _vm.wizardAnswers.products.whole_life
                                    .standAlonePoliciesSupported,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.wizardAnswers.products.whole_life,
                                    "standAlonePoliciesSupported",
                                    $$v
                                  )
                                },
                                expression:
                                  "wizardAnswers.products.whole_life.standAlonePoliciesSupported"
                              }
                            },
                            [
                              _vm._v(
                                "\n                  Yes\n                "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "radio",
                            {
                              attrs: {
                                name: "whole_life_stand_alone",
                                value: _vm.wizardAnswers.products.whole_life
                                  .supported
                                  ? false
                                  : null,
                                disabled: !_vm.wizardAnswers.products.whole_life
                                  .supported
                              },
                              model: {
                                value:
                                  _vm.wizardAnswers.products.whole_life
                                    .standAlonePoliciesSupported,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.wizardAnswers.products.whole_life,
                                    "standAlonePoliciesSupported",
                                    $$v
                                  )
                                },
                                expression:
                                  "wizardAnswers.products.whole_life.standAlonePoliciesSupported"
                              }
                            },
                            [_vm._v("\n                  No\n                ")]
                          )
                        ],
                        1
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      class: {
                        "wizard-field wizard-field--conditional": true,
                        "wizard-field--disabled": !_vm.wizardAnswers.products
                          .whole_life.supported,
                        "has-error":
                          !_vm.slideChangeSuccess &&
                          _vm.wizardAnswers.products.whole_life.supported &&
                          _vm.wizardAnswers.products.whole_life
                            .stackedCoverageSupported === null
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          class: [
                            "wizard-field--conditional__question",
                            {
                              "has-error": _vm.errors
                                ? _vm.errors.has("whole_life_stacked")
                                : false
                            }
                          ]
                        },
                        [
                          _vm._v(
                            "\n                Will stacked coverage be needed?\n              "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "wizard-field--radio" },
                        [
                          _c(
                            "radio",
                            {
                              attrs: {
                                name: "whole_life_stacked",
                                value: _vm.wizardAnswers.products.whole_life
                                  .supported
                                  ? true
                                  : null,
                                disabled: !_vm.wizardAnswers.products.whole_life
                                  .supported
                              },
                              model: {
                                value:
                                  _vm.wizardAnswers.products.whole_life
                                    .stackedCoverageSupported,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.wizardAnswers.products.whole_life,
                                    "stackedCoverageSupported",
                                    $$v
                                  )
                                },
                                expression:
                                  "wizardAnswers.products.whole_life.stackedCoverageSupported"
                              }
                            },
                            [
                              _vm._v(
                                "\n                  Yes\n                "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "radio",
                            {
                              attrs: {
                                name: "whole_life_stacked",
                                value: _vm.wizardAnswers.products.whole_life
                                  .supported
                                  ? false
                                  : null,
                                disabled: !_vm.wizardAnswers.products.whole_life
                                  .supported
                              },
                              model: {
                                value:
                                  _vm.wizardAnswers.products.whole_life
                                    .stackedCoverageSupported,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.wizardAnswers.products.whole_life,
                                    "stackedCoverageSupported",
                                    $$v
                                  )
                                },
                                expression:
                                  "wizardAnswers.products.whole_life.stackedCoverageSupported"
                              }
                            },
                            [_vm._v("\n                  No\n                ")]
                          )
                        ],
                        1
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      class: {
                        "wizard-field wizard-field--checkbox": true,
                        "has-error":
                          !_vm.slideChangeSuccess &&
                          _vm.wizardAnswers.isQbpcChecked &&
                          _vm.wizardAnswers.qbpcLimitedOrOther === null
                      }
                    },
                    [
                      _c(
                        "checkbox",
                        {
                          attrs: { name: "isQbpcChecked" },
                          model: {
                            value: _vm.wizardAnswers.isQbpcChecked,
                            callback: function($$v) {
                              _vm.$set(_vm.wizardAnswers, "isQbpcChecked", $$v)
                            },
                            expression: "wizardAnswers.isQbpcChecked"
                          }
                        },
                        [_vm._v("\n                QBPC\n              ")]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      class: [
                        "wizard-field wizard-field--conditional",
                        {
                          "wizard-field--disabled": !_vm.wizardAnswers
                            .isQbpcChecked
                        },
                        {
                          "has-error": _vm.errors
                            ? _vm.errors.has("qbpcLimitedOrOther")
                            : false
                        }
                      ]
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "wizard-field--conditional__question wizard-field--stacked"
                        },
                        [
                          _c(
                            "radio",
                            {
                              attrs: {
                                name: "qbpcLimitedOrOther",
                                value: _vm.wizardAnswers.isQbpcChecked
                                  ? "limited"
                                  : (_vm.wizardAnswers.qbpcLimitedOrOther = null),
                                disabled: !_vm.wizardAnswers.isQbpcChecked
                              },
                              model: {
                                value: _vm.wizardAnswers.qbpcLimitedOrOther,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.wizardAnswers,
                                    "qbpcLimitedOrOther",
                                    $$v
                                  )
                                },
                                expression: "wizardAnswers.qbpcLimitedOrOther"
                              }
                            },
                            [
                              _vm._v(
                                "\n                  Group Cancer, Group Critical Illness, Banner VSTD, and Banner VGTL ONLY\n                "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "radio",
                            {
                              attrs: {
                                name: "qbpcLimitedOrOther",
                                value: _vm.wizardAnswers.isQbpcChecked
                                  ? "other"
                                  : (_vm.wizardAnswers.qbpcLimitedOrOther = null),
                                disabled: !_vm.wizardAnswers.isQbpcChecked
                              },
                              model: {
                                value: _vm.wizardAnswers.qbpcLimitedOrOther,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.wizardAnswers,
                                    "qbpcLimitedOrOther",
                                    $$v
                                  )
                                },
                                expression: "wizardAnswers.qbpcLimitedOrOther"
                              }
                            },
                            [
                              _vm._v(
                                "\n                  Other Products\n                "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("tab-content", { attrs: { beforeChange: _vm.checkSlide } }, [
                  _c("div", { staticClass: "wizard-quad-layout" }, [
                    _c(
                      "div",
                      {
                        class: {
                          "wizard-field wizard-field--checkbox": true,
                          "has-error":
                            !_vm.slideChangeSuccess &&
                            _vm.wizardAnswers.employerPaidSupport === null
                        }
                      },
                      [
                        _c("h3", { staticClass: "wizard-question" }, [
                          _vm._v("Will there be employer paid products?")
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "wizard-field--conditional__question wizard-field--stacked"
                          },
                          [
                            _c(
                              "radio",
                              {
                                attrs: {
                                  name: "employerPaidSupport",
                                  value: true,
                                  id: "employer-paid-support-yes-radio"
                                },
                                model: {
                                  value: _vm.wizardAnswers.employerPaidSupport,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.wizardAnswers,
                                      "employerPaidSupport",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "wizardAnswers.employerPaidSupport"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                    Yes\n                  "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "radio",
                              {
                                attrs: {
                                  name: "employerPaidSupport",
                                  value: false
                                },
                                model: {
                                  value: _vm.wizardAnswers.employerPaidSupport,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.wizardAnswers,
                                      "employerPaidSupport",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "wizardAnswers.employerPaidSupport"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                    No\n                  "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        class: {
                          "wizard-field wizard-field--checkbox": true,
                          "has-error":
                            !_vm.slideChangeSuccess &&
                            _vm.wizardAnswers.employee_75_seen_spoken === null
                        }
                      },
                      [
                        _c("h3", { staticClass: "wizard-question" }, [
                          _vm._v(
                            "Will 75% of your employees be  seen or spoken to?"
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "wizard-field--conditional__question wizard-field--stacked"
                          },
                          [
                            _c(
                              "radio",
                              {
                                attrs: {
                                  name: "employee_75_seen_spoken",
                                  value: true,
                                  id: "employee-75-seen-spoken-yes-radio"
                                },
                                model: {
                                  value:
                                    _vm.wizardAnswers.employee_75_seen_spoken,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.wizardAnswers,
                                      "employee_75_seen_spoken",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "wizardAnswers.employee_75_seen_spoken"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                    Yes\n                  "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "radio",
                              {
                                attrs: {
                                  name: "employee_75_seen_spoken",
                                  value: false
                                },
                                model: {
                                  value:
                                    _vm.wizardAnswers.employee_75_seen_spoken,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.wizardAnswers,
                                      "employee_75_seen_spoken",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "wizardAnswers.employee_75_seen_spoken"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                    No\n                  "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        class: {
                          "wizard-field wizard-field--checkbox": true,
                          "has-error":
                            !_vm.slideChangeSuccess &&
                            _vm.wizardAnswers.features.enrollment_agent_assisted
                              .available !== true &&
                            _vm.wizardAnswers.features.enrollment_self_enroll
                              .available !== true &&
                            _vm.wizardAnswers.features.enrollment_call_center
                              .available !== true &&
                            _vm.wizardAnswers.features.auto_census_enroll
                              .available !== true
                        }
                      },
                      [
                        _c("h3", { staticClass: "wizard-question" }, [
                          _vm._v("How do you plan to enroll?")
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _c("span", { staticClass: "text-help" }, [
                            _vm._v("Please check all that apply")
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "wizard-field--conditional__question wizard-field--flex"
                          },
                          [
                            _c(
                              "checkbox",
                              {
                                attrs: {
                                  name: "enrollment_agent_assisted",
                                  id: "enrollment-agent-assisted-checkbox"
                                },
                                model: {
                                  value:
                                    _vm.wizardAnswers.features
                                      .enrollment_agent_assisted.available,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.wizardAnswers.features
                                        .enrollment_agent_assisted,
                                      "available",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "wizardAnswers.features.enrollment_agent_assisted.available"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                    Agent Assisted\n                  "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "checkbox",
                              {
                                attrs: { name: "enrollment_self_enroll" },
                                model: {
                                  value:
                                    _vm.wizardAnswers.features
                                      .enrollment_self_enroll.available,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.wizardAnswers.features
                                        .enrollment_self_enroll,
                                      "available",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "wizardAnswers.features.enrollment_self_enroll.available"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                    Self Enroll\n                    "
                                ),
                                this.hasNonStandardProducts
                                  ? _c("sup", [_vm._v("*")])
                                  : _vm._e()
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "checkbox",
                              {
                                attrs: { name: "enrollment_call_center" },
                                model: {
                                  value:
                                    _vm.wizardAnswers.features
                                      .enrollment_call_center.available,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.wizardAnswers.features
                                        .enrollment_call_center,
                                      "available",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "wizardAnswers.features.enrollment_call_center.available"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                    Call Center\n                  "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "checkbox",
                              {
                                attrs: { name: "auto_census_enroll" },
                                model: {
                                  value:
                                    _vm.wizardAnswers.features
                                      .auto_census_enroll.available,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.wizardAnswers.features
                                        .auto_census_enroll,
                                      "available",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "wizardAnswers.features.auto_census_enroll.available"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                    Census Enroll\n                  "
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        this.hasNonStandardProducts
                          ? _c("div", { staticClass: "wizard__help-text" }, [
                              this.hasNonStandardProducts &&
                              this.hasStandardProducts
                                ? _c("em", [
                                    _vm._v(
                                      "\n                    *Note: Self Enroll is not available for Universal Life or QBPC.\n                  "
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              this.hasNonStandardProducts &&
                              !this.hasStandardProducts
                                ? _c("em", [
                                    _vm._v(
                                      "\n                    *Note: Self Enroll is not an option when Universal Life or QBPC are selected.\n                  "
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              this.hasNonStandardProducts &&
                              this.hasStandardProducts &&
                              this.wizardAnswers.features
                                .enrollment_agent_assisted.available !== true &&
                                this.wizardAnswers.features
                                  .enrollment_call_center.available !== true
                                ? _c("em", { staticClass: "has-error" }, [
                                    _vm._v(
                                      "\n                    Selection of "
                                    ),
                                    _c("strong", [_vm._v("Agent Assisted")]),
                                    _vm._v(" and/or\n                    "),
                                    _c("strong", [_vm._v("Call Center")]),
                                    _vm._v(" is required.\n                  ")
                                  ])
                                : _vm._e()
                            ])
                          : _vm._e()
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        class: {
                          "wizard-field wizard-field--checkbox": true,
                          "has-error":
                            !_vm.slideChangeSuccess &&
                            _vm.wizardAnswers.buildCaseInternal !== true &&
                            _vm.wizardAnswers.buildCaseExternal !== true
                        }
                      },
                      [
                        _c("h3", { staticClass: "wizard-question" }, [
                          _vm._v("Who will be building the case?")
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _c("span", { staticClass: "text-help" }, [
                            _vm._v("Please check all that apply")
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "wizard-field--conditional__question wizard-field--stacked"
                          },
                          [
                            _c(
                              "checkbox",
                              {
                                attrs: {
                                  name: "buildCaseInternal",
                                  id: "build-case-internal-checkbox"
                                },
                                model: {
                                  value: _vm.wizardAnswers.buildCaseInternal,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.wizardAnswers,
                                      "buildCaseInternal",
                                      $$v
                                    )
                                  },
                                  expression: "wizardAnswers.buildCaseInternal"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                    Broker or Coordinator\n                  "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "checkbox",
                              {
                                attrs: { name: "buildCaseExternal" },
                                model: {
                                  value: _vm.wizardAnswers.buildCaseExternal,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.wizardAnswers,
                                      "buildCaseExternal",
                                      $$v
                                    )
                                  },
                                  expression: "wizardAnswers.buildCaseExternal"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                    System or Vendor\n                  "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                !_vm.validated && !_vm.slideChangeSuccess
                  ? _c("div", { staticClass: "errorSummary" }, [
                      _vm.nextSlideIndex === null || _vm.nextSlideIndex === 0
                        ? _c("p", [
                            _vm._v(
                              "\n              Please make a selection.\n            "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.nextSlideIndex === 2
                        ? _c("p", [
                            _vm._v(
                              "\n              Please make at least one product selection.\n            "
                            )
                          ])
                        : _vm._e()
                    ])
                  : _vm._e()
              ],
              1
            )
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wizard__head" }, [
      _c("h2", [_vm._v("Help Me Choose a Platform")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c21d83ca", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c21d83ca","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Wizard.vue
// module id = null
// module chunks = 